import React, { useEffect, useState } from "react";
import { db, collection, onSnapshot } from "../boardData";
import { WidgetShell, EmptyState } from "./common";

function lowStock(item) {
  if (item.lowStock === true) return true;
  const qty = Number(item.quantity ?? item.qty);
  const thr = Number(item.threshold ?? item.reorderPoint ?? item.minQuantity);
  if (Number.isFinite(qty) && Number.isFinite(thr)) return qty <= thr;
  return false;
}

// Supplies / inventory from Agencies/{agency}/Inventory; optional low-stock filter.
const InventoryWidget = ({ config = {}, agency }) => {
  const [items, setItems] = useState([]);
  const lowOnly = config.lowStockOnly === true;
  const locationFilter = (config.location || "").toLowerCase();

  useEffect(() => {
    if (!agency) return undefined;
    const unsub = onSnapshot(
      collection(db, "Agencies", agency, "Inventory"),
      (snap) => {
        let list = snap.docs
          .map((d) => ({ id: d.id, ...d.data() }))
          .filter((it) => it.name || it.itemName)
          .map((it) => ({ ...it, _name: it.name || it.itemName, _low: lowStock(it) }));
        if (locationFilter) {
          list = list.filter((it) => String(it.location || "").toLowerCase().includes(locationFilter));
        }
        if (lowOnly) list = list.filter((it) => it._low);
        list.sort((a, b) => Number(b._low) - Number(a._low) || String(a._name).localeCompare(String(b._name)));
        setItems(list.slice(0, 40));
      },
      (err) => console.warn("inventory load failed", err)
    );
    return () => unsub();
  }, [agency, lowOnly, locationFilter]);

  return (
    <WidgetShell title={lowOnly ? "Low Stock" : "Inventory"}>
      {items.length === 0 ? (
        <EmptyState icon="📦" label={lowOnly ? "Nothing low on stock." : "No inventory items."} />
      ) : (
        <div className="sb-inv-list">
          {items.map((it) => (
            <div className={`sb-inv ${it._low ? "low" : ""}`} key={it.id}>
              <span className="sb-inv-name">{it._name}</span>
              <span className="sb-inv-qty">{it.quantity ?? it.qty ?? "—"}</span>
            </div>
          ))}
        </div>
      )}
    </WidgetShell>
  );
};

export default InventoryWidget;
